import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { PatientContext } from "../../contexts/PatientContext.tsx";
import { patientActivityLogs } from "../../models/patient";
import { useFetch } from "../../services/hooks/useFetch";
import { apiPrefix } from "../../utils/main";
import Activity from "./Activity";
import ActivityCard from "./activitycard/ActivityCard";

export default function PatientActivity({
  onClose,
  onLoadVisit,
}: {
  onClose: () => void;
  onLoadVisit: (visitId: string) => void;
}) {
  const { id } = useContext(PatientContext)!;
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const { fetch, data: logs } = useFetch<
    ActivityLogWithDate[],
    undefined,
    ActivityLog[]
  >();

  const hyperlink = {
    action: onLoadVisit,
  };

  useEffect(() => {
    void fetch(`${apiPrefix}/projects/${projectId}/activity/patients/${id}`, {
      responseManipulationFunction: (data) => {
        return patientActivityLogs(data);
      },
    });
  }, [projectId, id, fetch]);

  return (
    <Activity title={"Patient Activity"} onClose={onClose} logs={logs}>
      {(log) => (
        <ActivityCard
          key={log.id}
          cardType={"patient"}
          log={log}
          hyperlink={hyperlink}
        />
      )}
    </Activity>
  );
}
